/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosInstance } from 'axios';

import { baseUrl } from './types';

export const accountsClient = (request: AxiosInstance) => ({
  async inviteNotary(email: string): Promise<void> {
    return (await request.post(`${baseUrl}/accounts`, { email })).data;
  },
});
